import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentRemove from 'material-ui/svg-icons/action/delete';

/**
 * A component for creating a named item with optional removal.
 * Loaded by AdditionalTaxesTable.
 *
 */
class AdditionalTaxTableRow extends Component {
    constructor(props) {
        super(props);
        this.handleRemoveClick = this.handleRemoveClick.bind(this);
    }

    handleRemoveClick() {
        this.props.onRemoveClick(this.props.item.machine_name);
    }

    render() {
        const {
            item
        } = this.props;

        const styles = {
            row: {minHeight: '40px', verticalAlign: 'middle'},
            rowSmall: {minHeight: '40px', maxWidth: 100, verticalAlign: 'middle'},
            rowWrap: {minHeight: '40px', whiteSpace: 'wrap', verticalAlign: 'middle'},
            icon: {height: '40px', padding: '10px', overflow: 'inherit'},
        };

        return (
            <TableRow style={styles.row}>
                <TableRowColumn className={'row-at-name-' + item.machine_name} style={styles.row}>
                    <span>{item.name}</span>
                </TableRowColumn>
                <TableRowColumn className={'row-at-desc-' + item.machine_name} style={styles.rowWrap}>
                    <span>{item.description}</span>
                </TableRowColumn>
                <TableRowColumn className={'row-at-rate-' + item.machine_name} style={styles.rowSmall}>
                    <span>{item.tax_rate_percent}</span>
                </TableRowColumn>
                {this.props.showRemove &&
                    <TableRowColumn style={styles.rowSmall}>
                        <IconButton
                            style={styles.icon}
                            onClick={(e) => this.handleRemoveClick(e)}
                        >
                            <ContentRemove color={FuseTheme.palette.primary1Color}/>
                        </IconButton>

                    </TableRowColumn>
                }
            </TableRow>
        )
    }
}

AdditionalTaxTableRow.propTypes = {
    addField: PropTypes.bool,
    item: PropTypes.object.isRequired,
    showRemove: PropTypes.bool,
    onRemoveClick: PropTypes.func,
};

AdditionalTaxTableRow.defaultProps = {
    addField: true,
    item: {},
    style: {padding: 0},
};

export default AdditionalTaxTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/AdditionalTaxTableRow.js